require("./exAntCostRightBuy.scss");
// @ vendor
const React = require("react");
const { withRouter } = require("react-router-dom");
const PropTypes = require("prop-types");
const { FormattedText, formatText } = require('core/i18n').i18n;

// @components
const BlockInfo = require("components/contactCenter/blockInfo/blockInfo");
const BrokerExAntSection = require("components/commons/brokerExAntSection/brokerExAntSection");
const { LoadingSection } = require('commonsComponents/loadingSection');

// @ constants
const {
    BROKER_ORDER_TYPE_FOR_THE_BEST,
    BROKER_ORDER_TYPE_TO_MARKET,
    POTENTIAL_SELL_RIGHT_COSTS,
    POTENTIAL_COST
} = require('constants/index');

// @helpers
const {
    formatCurrency,
    formatWithoutRound,
    formatPercentage
} = require('utilities/currencyHelper');

class ExAntCostRightBuy extends React.Component {
    constructor(props) {
        super(props);

        this.buildDetails = this.buildDetails.bind(this);
        this.buildContent = this.buildContent.bind(this);
    }

    componentDidMount() {
        const { fetchExAntCostBuyRight, history } = this.props
        fetchExAntCostBuyRight(history);
    }

    getOrderType(orderType) {
        if (orderType === BROKER_ORDER_TYPE_TO_MARKET) {
            return formatText('brokerETFBuy-ETFBuyStep1ToMarketLabel');
        } else if (orderType === BROKER_ORDER_TYPE_FOR_THE_BEST) {
            return formatText('brokerETFBuy-ETFBuyStep1ForTheBestLabel');
        } else {
            return formatText('brokerETFBuy-ETFksBuyStep1LimitedLabel');
        }
    }


    buildContent() {
        const { immBrokerRightsBuy } = this.props;
        const dataExtant = immBrokerRightsBuy.getIn(['exAnteCostsList']);
        const exAnteCostList = dataExtant.getIn(['exAnteCostList']);
        let data;
        if (immBrokerRightsBuy.getIn(['exAnteDataFetching'])) {
            data = <LoadingSection />;
        } else if (exAnteCostList) {
            data = exAnteCostList.map(
              (item, index) =>
                item.get('type') !== POTENTIAL_COST && (
                <BrokerExAntSection
                    context="brokerRightBuy"
                    eventCategory="orden compra fondos/paso 2"
                    section={item}
                    key={index}
                    complexTooltip={true}
                  />
                )
            );
        }
        return (
            <div className="broker-buy-right-description__column-container">
                {data}
            </div>
        );
    }

    buildDetails(title, footer = null) {
        return (
            <React.Fragment>
                <div className="broker-buy-right-description__title-description">
                    {title}
                </div>
                <div className="broker-buy-right-description__web-wrapper__container">
                    {this.buildContent()}
                </div>
                <span className="broker-buy-right-description__footer">
                    {footer}
                </span>
            </React.Fragment>
        );
    }

    renderExtantDataWeb() {
        const { immBrokerRightsBuy } = this.props;
        let potentialSellRightCostsText;
       const dataExtant = immBrokerRightsBuy.getIn(['exAnteCostsList']);
        const exAnteCostList = dataExtant && dataExtant.getIn(['exAnteCostList']) && dataExtant.getIn(['exAnteCostList']).toJS();

        const potentialSellRightCosts  = exAnteCostList && exAnteCostList.find(
            (item) => item.descriptionKey === POTENTIAL_SELL_RIGHT_COSTS
        );

        if (potentialSellRightCosts && potentialSellRightCosts.type === POTENTIAL_COST) {
            const dataPotentialCosts = potentialSellRightCosts.details[0];
            const currency = formatCurrency(dataPotentialCosts.currency ? dataPotentialCosts.currency : 'EUR');
            const amount = formatWithoutRound(dataPotentialCosts.amount, 2);
            const immPercentage = formatPercentage(dataPotentialCosts.percentage, 2);
            const formatAmount = `${amount} ${currency}`;

            potentialSellRightCostsText = formatText('brokerRightBuy-exantCost_potentialCost_footer', [formatAmount, immPercentage]);
        } else {
            potentialSellRightCostsText =  (<FormattedText
                value="brokerETFBuy-extantCost_footer_description"
            />)
        }
        return (
            <div className="broker-buy-right-description__web-wrapper">
                <div className="broker-buy-right-description__web-wrapper__container">
                    {this.buildContent()}
                </div>
                <div className="broker-buy-right-description__footer">
                    {potentialSellRightCostsText}
                </div>
            </div>
        );
    }

    render() {
        return __CONTACT_CENTER__ ? (
            <BlockInfo extraClass="broker-buy-right-description__block-info">
                {this.buildDetails(
                    formatText('brokerETFBuy-extantCost_description_cc'),
                    formatText('brokerETFBuy-extantCost_footer_description_cc')
                )}
            </BlockInfo>
        ) : (
            <div>
                {this.renderExtantDataWeb()}
            </div>
        );
    }
}

ExAntCostRightBuy.propTypes = {
    fetchExAntCostBuyRight: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immBrokerRightsBuy: PropTypes.object.isRequired,
};

module.exports.constructor = ExAntCostRightBuy;

export default withRouter(ExAntCostRightBuy);
